import { render, staticRenderFns } from "./visualBooking.vue?vue&type=template&id=4bca3ee8"
import script from "./visualBooking.vue?vue&type=script&lang=ts"
export * from "./visualBooking.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports